require('./OKWizardError.scss');

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
const { withRouter } = require('react-router-dom');
import classnames from 'classnames';
import PureRenderMixin from 'react-addons-pure-render-mixin';

// @common-components
import { OKButton } from 'commonsComponents/OKButton';
import OKTag from 'components/commons/OKTag/OKTag';
import { OKBoxTitle } from 'commonsComponents/OKBoxTitle';

// @constants
import { recordProcess, PROC_FAIL } from 'utilities/tagging';
const {
    OPERATION_LOG_TYPE_FINISH,
    OPERATION_LOG_FAIL,
    OPERATION_LOG_TYPE_INITIALIZE,
    OPERATION_LOG_TYPE_ENTRY
} = require('utilities/contactCenter/wrapUp/constants');

//@utilities
import  { traceFlowEvent } from 'utilities/contactCenter/wrapUp/wrapUpCore';

class OKWizardError extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCancleButtonClick = this.handleCancleButtonClick.bind(this);
    }

    componentDidMount () {
        recordProcess(this.props.processType, PROC_FAIL, this.props.tealium);
        if (__CONTACT_CENTER__) {
            const {errorMessage, errorSubMessage} = this.props;
            const optionalSubMessage = (typeof errorSubMessage === "string" || errorSubMessage instanceof String) ? ` : ${errorSubMessage}` : '';
            const completeError = errorMessage + optionalSubMessage;
            const operatioLogType = traceFlowEvent.getCurrentState() === OPERATION_LOG_TYPE_INITIALIZE ?
                OPERATION_LOG_TYPE_ENTRY : OPERATION_LOG_TYPE_FINISH
            traceFlowEvent.notify(operatioLogType, OPERATION_LOG_FAIL, completeError)
            traceFlowEvent.reset()
        }
    }
    handleCancleButtonClick() {
        const { onCancleButtonClick, cancleButton: {url}, history } = this.props;

        return (onCancleButtonClick) ? onCancleButtonClick() : (url) ? history.push(url) : history.goBack();
    }

    handleMainButtonClick = () => {
        const { history, onMainButtonClick, mainButton: { url, action }} = this.props;
        action();
        return onMainButtonClick ?
                onMainButtonClick() :
                url ? history.push(url) : history.goBack();
    }

    handleRedirectToSecondaryButtonURL = () => {
        const { history, secondaryButton: { url }} = this.props;

        if (url) {
            history.push(url);
        } else {
            history.goBack();
        }
    }

    render() {
        const {
            errorMessage,
            errorSubMessage,
            errorTagLabelSubMessage,
            customClassName,
            children,
            mainButton,
            secondaryButton,
            cancleButton
        } = this.props;

        const classNames = classnames('ok-wizard-error', customClassName);
        let myMainButton;
        let mySecondaryButton;
        let myCancleButton;
        let myButtons;
        let errorTag;

        if (mainButton.label) {
            myMainButton = (
                <div className="ok-wizard-error__main-button">
                    <OKButton
                        id="lnk_wizardErrorStep_mainButton"
                        modifier="link-complementary"
                        onClick={this.handleMainButtonClick}
                    >
                        {mainButton.label}
                    </OKButton>
                </div>
            );
        }

        if (secondaryButton.label) {
            mySecondaryButton = (
                <div className="ok-wizard-error__secondary-button">
                    <OKButton
                        id="lnk_wizardErrorStep_secondaryButton"
                        modifier="link-ghost"
                        onClick={this.handleRedirectToSecondaryButtonURL}
                    >
                        {secondaryButton.label}
                    </OKButton>
                </div>
            );
        }
        if (cancleButton.label) {
            myCancleButton = (
                <div className="wizard-error-step__cancle-button">
                    <OKButton
                        id="lnk_wizardErrorStep_cancleButton"
                        modifier="link-complementary"
                        onClick={this.handleCancleButtonClick}
                    >
                        {cancleButton.label}
                    </OKButton>
                </div>
            );
        }

        if (myMainButton || mySecondaryButton || myCancleButton) {
            myButtons = (
                <div className="ok-wizard-error__footer">
                    <div className="ok-wizard-error__separator" />
                    <div className="ok-wizard-error__foot-buttons">
                    {myCancleButton} {myMainButton} {mySecondaryButton}
                    </div>
                </div>
            );
        }

        if (Boolean(errorTagLabelSubMessage)) {
            errorTag = (
                <div className="ok-wizard-error__error-tag-label-message">
                    <OKTag content={errorTagLabelSubMessage} type="warning" emphasis={true} context="action"/>
                </div>
            )
        }

        return (
            <div className={classNames}>
                <div className="ok-wizard-error__highlight">
                    <i className="ok-wizard-error__error-icon">
                    </i>
                    <div className="ok-wizard-error__messages">
                        <OKBoxTitle value={errorMessage}/>
                        <div className="ok-wizard-error__error-sub-message">
                            {errorSubMessage}
                            {errorTag}
                        </div>
                    </div>
                </div>
                <div className="ok-wizard-error__content">
                    {children}
                </div>
                {myButtons}
            </div>
        );
    }
}

OKWizardError.defaultProps = {
    mainButton: {},
    processType: null,
    secondaryButton: {},
    tealium: {},
    customClassName: ''
};

OKWizardError.propTypes = {
    errorMessage: PropTypes.string,
    errorSubMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    errorTagLabelSubMessage: PropTypes.string,
    customClassName: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
    ]),
    mainButton: PropTypes.object,
    processType: PropTypes.string,
    secondaryButton: PropTypes.object,
    tealium: PropTypes.object,
    history: PropTypes.object.isRequired,
    onMainButtonClick: PropTypes.func
};

module.exports = withRouter(OKWizardError);
